import { put, call, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import { GET_AGENCIES, GET_AGENCY_VIEW } from "../../services/ApiCalls";

function* getAgenciesDataSaga({ payload, params, callBack }) {
  try {
    const response = yield call(GET_AGENCIES, payload, params);
    if (response.data.status == "success") {
      yield put(ACTION.getAgenciesSuccess(response?.data));
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.getAgenciesFail(error));
    }
  } catch (error) {
    yield put(ACTION.getAgenciesFail(error));
  }
}

function* getAgenciesViewDataSaga({ payload, callBack }) {
  try {
    const response = yield call(GET_AGENCY_VIEW, payload);
    if (response.status == 200) {
      console.log(response);
      yield put(ACTION.getAgencyViewSuccess(response?.data));
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.getAgencyViewFail(error));
    }
  } catch (error) {
    yield put(ACTION.getAgencyViewFail(error));
  }
}

function* agencySaga() {
  yield takeEvery(CONST.GET_AGENCIES, getAgenciesDataSaga);
  yield takeEvery(CONST.GET_AGENCY_VIEW, getAgenciesViewDataSaga);
}

export default agencySaga;
